import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DayElapsePipe } from './day-elapse.pipe';

@NgModule({
  declarations: [DayElapsePipe],
  imports: [CommonModule],
  exports: [DayElapsePipe]
})
export class DayElapseModule {}
